import { ClassTypeType, RootState } from "shared/types";

export const selectBranding = () => (state: RootState) => state.classroom.client.info.branding;

export const selectClassDashboardPath = () => (state: RootState) =>
  `courses/${state.classroom.client.info.course.id}/sections/${state.classroom.client.info.section.id}/classes/${state.classroom.client.info.id}`;

export const selectClassId = () => (state: RootState) => state.classroom.client.info.id;

export const selectClassInfo = () => (state: RootState) => state.classroom.client.info;

export const selectIsInPersonClass = () => (state: RootState) => {
  const { is_in_flight, type } = state.classroom.client.info;
  return type === ClassTypeType.InPerson || !is_in_flight; // the latter prevents a rerender before transitioning to Forum
};

export const selectLoading = () => (state: RootState) => state.classroom.client.info.id === "-1";

export const selectOrgId = () => (state: RootState) => state.classroom.client.info.org.id;

export const selectOrgName = () => (state: RootState) => state.classroom.client.info.org.name || "";

export const selectSection = () => (state: RootState) => state.classroom.client.info.section;

export const selectTitle = () => (state: RootState) => state.classroom.client.info.title;
